import {AnyEvent, JOB_VARIATION_ITEM_CREATED, JobVariationItemCreatedEvent} from '../type';

export default function jobVariationItemCreated(payload: JobVariationItemCreatedEvent['payload']): AnyEvent {
  return {
    type: JOB_VARIATION_ITEM_CREATED,
    payload,
  }
}